import { render, staticRenderFns } from "./Resume.vue?vue&type=template&id=33f510e4&scoped=true&"
import script from "./Resume.vue?vue&type=script&lang=ts&"
export * from "./Resume.vue?vue&type=script&lang=ts&"
import style0 from "./Resume.vue?vue&type=style&index=0&id=33f510e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f510e4",
  null
  
)

export default component.exports